<template>
  <footer class="footer" :class="{ visible: isVisible }">
    <p>&copy; {{ currentYear }} Amite Clothing. All rights reserved.</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      isVisible: false,
      currentYear: new Date().getFullYear()
    }
  },
  mounted() {
    setTimeout(() => {
      this.isVisible = true;
    }, 900);
  }
}
</script>